module.exports = __webpack_public_path__ + "img/19292200.6b0a38f5.jpg";